module.exports = __webpack_public_path__ + "static/logo-1@2x-3adc9023fc2b13c067bd8951214c7237.png";